export default "__VITE_ASSET__D0ebo5tP__"